import { AllCardsType } from '../../../data/all-cards'
import { NombreTarotista } from '../../../data/personality'
import { DataTypePregunta } from '../../../interfaces/utils'
import { formatCardLabel } from '../../../utils/card-label'

const cardLabel = (card: AllCardsType) => formatCardLabel(card)

export const interpret = (
    cards: AllCardsType[],
    data: DataTypePregunta,
    user: string,
    personality: NombreTarotista,
    type: string
) => {
    const consult = `Quiero que interpretes una **Tirada de Amor Propio y Merecimiento** con 10 cartas, ayudando al consultante ${
        data.consultante
    } a sanar su relación consigo mismo/a, liberar bloqueos de merecimiento y abrirse a recibir amor y cuidado, ${
        data.consulta.length > 0
            ? 'ten en cuenta en la tirada la siguiente consulta que realiza el consultante: ' +
              data.consulta +
              ','
            : ''
    } según estas cartas: **Relación actual con el amor propio — Estado actual (¿cómo te estás tratando a vos mismo/a hoy? ¿Hay autocrítica, descuido o hay algo de cuidado?):** ${cardLabel(
        cards[0]
    )}, **Principal bloque de merecimiento — Bloque principal (¿cuál es la creencia o sensación más fuerte que te impide sentirte merecedor/a?):** ${cardLabel(
        cards[1]
    )}, **Origen del bloque — Raíz (¿de dónde viene esa dificultad para sentirte merecedor/a? infancia, familia, relaciones pasadas):** ${cardLabel(
        cards[2]
    )}, **Cómo se manifiesta en tu vida — Manifestación actual (¿de qué forma concreta te está afectando este bloque hoy en amor, dinero, oportunidades o vínculos?):** ${cardLabel(
        cards[3]
    )}, **Qué te estás negando — Privación actual (¿qué amor, cuidado o experiencia te estás privando por no sentirte merecedor/a?):** ${cardLabel(
        cards[4]
    )}, **Miedo que hay detrás — Miedo raíz (¿qué miedo aparece cuando pensás en recibir más amor o cuidado?):** ${cardLabel(
        cards[5]
    )}, **Qué tenés que soltar — Liberación (¿qué creencia, patrón o forma de relacionarte con vos mismo/a necesitás dejar ir?):** ${cardLabel(
        cards[6]
    )}, **Qué necesitás activar / cultivar — Activación (¿qué cualidad o forma de amarte necesitás desarrollar o permitir?):** ${cardLabel(
        cards[7]
    )}, **Acción concreta de amor propio — Paso accionable (¿qué podés hacer de forma práctica y amorosa para empezar a sentirte más merecedor/a?):** ${cardLabel(
        cards[8]
    )} y **Mensaje de tu Yo Superior / Alma — Mensaje sanador y cierre (¿qué quiere recordarte tu parte más sabia sobre tu merecimiento?):** ${cardLabel(
        cards[9]
    )}. Explica detalladamente cada carta y su significado en la posición donde ha salido. Teje una lectura coherente sobre el amor propio y el merecimiento: conecta cómo te tratás hoy, el bloque principal, su origen, cómo se manifiesta, lo que te negás y el camino hacia la liberación y la activación. Detecta patrones de autocrítica, miedos al merecimiento y oportunidades de autocuidado. Proporciona consejos prácticos, tiernos y concretos para cultivar el amor propio. Mantén un tono profesional, empático, sanador y comprensible. Dirígete directamente al consultante, no utilices la tercera persona refiriéndote al consultante, aún cuando las consultas se encuentren en tercera persona, adapta la respuesta para que quede en segunda persona. Incluye además en 2 párrafos después de la lectura, una respuesta directa para el consultante y un consejo final (extra-tarot).`

    return {
        consult,
        user,
        personality,
        clientName: data.consultante.name,
        clientPhone: data.consultante.phone || '',
        clientAnswer: data.consulta,
        cards,
        type,
    }
}
